import React from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarCategoriaServicoDs } from "../DataSources";
import UserInfo from "../UserInfo";




export default class CategoriasAliquotasIssBox extends React.Component {

    constructor(){
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }
    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="CATEGORIAS DE ALÍQUOTAS DE ISS">
                    <DataGrid
                        dataSource={criarCategoriaServicoDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        columnAutoWidth={true}
                        focusedRowEnabled={true} 
                        onInitNewRow={this.initNewRow}>
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e){
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}